import { JanelaModal } from '../../participantes/ui/JanelaModal';

interface ConfirmacaoDeDesfazerProps {
    processando: boolean;
    aoCancelar: () => void;
    aoConfirmar: () => void;
}

/** O popup "Desfazer liderança?" com o texto novo da `DP-RA-041` (o sorteio da `DP-RA-049`). */
export function ConfirmacaoDeDesfazer({ processando, aoCancelar, aoConfirmar }: ConfirmacaoDeDesfazerProps) {
    return (
        <JanelaModal titulo="Desfazer liderança?" aoFechar={aoCancelar} bloqueada={processando}>
            <p>Desfazer a liderança deste(a) participante fará o sistema sortear outro(a) líder entre os membros ativos do grupo.</p>
            <p>O grupo continuará na mesma estação, sem perder seu progresso.</p>
            <div className="botoes-confirmacao">
                <button type="button" className="botao-secundario" onClick={aoCancelar} disabled={processando}>
                    Cancelar
                </button>
                <button type="button" className="botao-confirmar" onClick={aoConfirmar} disabled={processando}>
                    {processando ? 'Processando…' : 'Continuar'}
                </button>
            </div>
        </JanelaModal>
    );
}
